
import {
    StoryboardFrame,
    StoryboardFrameRegenerationOptions,
    StoryboardGenerationOptions,
    StoryboardImageGenerationOptions,
} from '@/features/storyboard/types/storyboard.types';
import { useAppMutation } from '@/shared/hooks/useAppMutation';
import { AppError } from '@/shared/types/AppError';
import { HookOptions } from '@/shared/types/HookOptions';
import { storyboardAIService } from '../service/storyboard.ai.service';

export const useGenerateStoryboardMutation = (
    options?: HookOptions<StoryboardFrame[], AppError, StoryboardGenerationOptions>
) => {
    return useAppMutation<StoryboardFrame[], AppError, StoryboardGenerationOptions>({
        mutationFn: (vars) => storyboardAIService.generateStoryboard(vars),
    }, options);
};

export const useGenerateFrameImageMutation = (
    options?: HookOptions<
        { success: boolean; imageUrl: string },
        AppError,
        StoryboardImageGenerationOptions
    >
) => {
    return useAppMutation<
        { success: boolean; imageUrl: string },
        AppError,
        StoryboardImageGenerationOptions
    >({
        mutationFn: (frame) => storyboardAIService.generateFrameImage(frame),
    }, options);
};

export const useRegenerateFrameMutation = (
    options?: HookOptions<StoryboardFrame, AppError, StoryboardFrameRegenerationOptions>
) => {
    return useAppMutation<StoryboardFrame, AppError, StoryboardFrameRegenerationOptions>({
        mutationFn: (vars) => storyboardAIService.regenerateSingleFrame(vars),
    }, options);
};
